import { render } from "./AboutUsPthPrishente.vue?vue&type=template&id=54235369&scoped=true"
import script from "./AboutUsPthPrishente.vue?vue&type=script&lang=js"
export * from "./AboutUsPthPrishente.vue?vue&type=script&lang=js"

import "./AboutUsPthPrishente.vue?vue&type=style&index=0&id=54235369&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54235369"]])

export default __exports__